import React, { useEffect } from 'react';
import LogoSVG from 'components/logo';
import styled from 'theme/styled';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import Welcome from './pages/welcome';
import TermsAndConditions from './pages/terms-and-conditions';
import CreateProfile from './pages/create-profile';
import { UserFromCacheProvider } from './user/context';
import { saveUserToCache, getUserFromCacheOrURL } from './user';

export default function Onboarding2(): JSX.Element {
  const user = getUserFromCacheOrURL();

  useEffect(() => {
    if (user) {
      saveUserToCache(user);
    }
  }, []);

  if (!user) {
    return <p>404</p>;
  }

  return (
    <Container>
      <header className='header'>
        <LogoSVG />
      </header>

      <UserFromCacheProvider value={user}>
        <Router>
          <Switch>
            <Route path='/signup/create-profile' component={CreateProfile} />
            <Route
              path='/signup/terms-and-conditions'
              component={TermsAndConditions}
            />
            <Route path='/signup' exact component={Welcome} />
          </Switch>
        </Router>
      </UserFromCacheProvider>
    </Container>
  );
}

const Container = styled.div`
  main {
    max-width: 1024px;
    margin: 0 auto;
    padding: 0 2em 4em 2em;
  }

  .header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 2em;
    padding: 3em 2em;

    svg {
      height: 2em;
      .icon {
        fill: ${({ theme }) => theme.palette.primary.main};
      }
    }
  }

  img {
    align-self: center;
    max-width: 25em;
  }

  article {
    margin-bottom: 3em;
  }

  section {
    /* text-align: center; */
  }

  .welcome {
    color: ${({ theme }) => theme.palette.primary.main};
    font-size: 3em;
    font-weight: 900;
  }
`;
